import { render, staticRenderFns } from "./GlobalCommandPalette.vue?vue&type=template&id=27c80cf1&"
import script from "./GlobalCommandPalette.vue?vue&type=script&lang=js&"
export * from "./GlobalCommandPalette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports